import React, { useState } from "react";
import Calendar from "react-calendar";
import globalStyle from "../../../../style/titanStyle";
import CalendarContent from "./CalendarContent/CalendarContent";
import "./CalendarComponent.css";
import useResources from "../../../../services/listing.service";
import {
  formateWithTz,
  formateCalendarDate,
  formatDateTimeStamp,
  formateTimer,
} from "../../../../shared/dateFormat";
// import { getFilterDate } from "../../../../shared/helpers";
import ReactPlaceholderLoader from "../../../../components/ReactPlaceholderLoader/ReactPlaceholderLoader";
export default function CalendarComponent(props) {
  const { card } = props;
  const globalClasses = globalStyle();
  const [selectedDate, setSelectedDate] = useState(formateWithTz(new Date()));
  const [toggle, setToggle] = useState("date");
  const [selectedMonth, setSelectedMonth] = useState(formateWithTz(new Date()));
  const onChange = (date) => {
    let newDate = formateTimer(date);
    setSelectedDate(newDate);
    setToggle("date");
  };
  const [monthlyData] = useResources(
    "get/list/diary",
    0,
    100,
    "startTime",
    "ASC",
    "month",
    selectedMonth,
    [],
    true,
    "",
  );
  // const [monthlyReminder, setMonthlyReminder] = useState(
  //   getFilterDate(monthlyData),
  // );

  const [data, count, isLoading] = useResources(
    "get/list/diary",
    0,
    100,
    "startTime",
    "ASC",
    "date",
    selectedDate,
    [],
    true,
    "",
  );

  const getMonthReminders = (value, event) => {
    setToggle("month");
    let date = formateCalendarDate(value);
    setSelectedMonth(date);
  };
  return (
    <>
      {/* calendar */}
      <div className={globalClasses.padding_10}>
        <Calendar
          onChange={onChange}
          next2Label={null}
          prev2Label={null}
          onClickMonth={(value, event) => getMonthReminders(value, event)}
          value={new Date()}
          // selectRange={true}
          // value={getFilterDate(monthlyData)}
        />
      </div>
      {/* Divider */}
      <hr />
      {/* Date wise data */}
      <div>
        <div className={"p-2 calendar-date"}>
          {toggle === "month"
            ? formatDateTimeStamp(selectedMonth)
            : formatDateTimeStamp(selectedDate)}
        </div>
        <div style={{ overflowY: "auto", height: card.height - 400 }}>
          {isLoading ? (
            <div className={"p-2"}>
              <ReactPlaceholderLoader type="media" rows={3} />
            </div>
          ) : toggle === "date" ? (
            data.length > 0 ? (
              data.map((diary) => {
                return <CalendarContent key={diary.indexId} diary={diary} />;
              })
            ) : (
              <div className={"no-data p-2"}> No data available</div>
            )
          ) : monthlyData.length > 0 ? (
            monthlyData.map((diary) => {
              return <CalendarContent key={diary.indexId} diary={diary} />;
            })
          ) : (
            <div className={"no-data p-2"}> No data available</div>
          )}
        </div>
      </div>
    </>
  );
}
